import { shopifyGraphQLClient } from '@/utils';
import { getWeeklyMenusKeys } from '@/utils/date';
import {
  GetCollectionByHandleQuery,
  GetCollectionHandlesQuery,
  GetCollectionQuery,
  GetProductQuery,
} from './graphql/generated/shopify';
import {
  getCollectionHandles,
  getCollectionQuery,
  getSingleCollectionQuery,
} from './graphql/shopify/queries/collection';
import { getProductQuery } from './graphql/shopify/queries/product';
import { getApiV2WeeklyMenusReviewSummaries } from './pensa';

export const getWeeklyMenus = () =>
  shopifyGraphQLClient.request<GetCollectionQuery>(getCollectionQuery, {
    query: `title:${getWeeklyMenusKeys().join(' OR ')}`,
  });

export const getCollection = (handle: string) =>
  shopifyGraphQLClient.request<GetCollectionByHandleQuery>(getSingleCollectionQuery, {
    handle,
  });

export const getAvailableMenus = () =>
  shopifyGraphQLClient.request<GetCollectionHandlesQuery>(getCollectionHandles);

export const getProductReviewsForMenus = async (menus: string[]) => {
  const result = await getApiV2WeeklyMenusReviewSummaries({
    start_dates: menus.join(','),
  });

  return result.included;
};

export const getProductById = async (id: string | number) => {
  const graphQLProductId =
    typeof id === 'string'
      ? id.startsWith('gid://shopify/Product/')
        ? id
        : `gid://shopify/Product/${id}`
      : `gid://shopify/Product/${id}`;

  return shopifyGraphQLClient.request<GetProductQuery>(getProductQuery, {
    id: graphQLProductId,
  });
};
